export default __webpack_public_path__ + "static/media/sole-user.c58c32f6.svg";